import BaseInput from 'components/inputs/BaseInput';
import { useLocale } from '@bluebeam/react-i18n';
import DatePicker, { registerLocale } from 'react-datepicker';

import * as locale from 'date-fns/locale';

interface Props {
  id: string;
  date: number | null;
  onChange: (date: Date) => void;
  placeholderText?: string;
  minDate?: Date | null;
  disabled?: boolean;
}

const DateDropdown = (props: Props) => {
  const { id, date, onChange, placeholderText, minDate, disabled } = props;
  const { languageCode } = useLocale() || 'en-US';

  let dateFormat = 'MM-dd-yyyy';

  switch (languageCode) {
    case 'da-DK': {
      registerLocale('dpLocale', locale.da);
      dateFormat = 'yyyy-MM-dd';
      break;
    }
    case 'en-AU': {
      registerLocale('dpLocale', locale.enAU);
      dateFormat = 'dd-MM-yyyy';
      break;
    }
    case 'en-GB': {
      registerLocale('dpLocale', locale.enGB);
      dateFormat = 'dd/MM/yy';
      break;
    }
    case 'de-DE': {
      registerLocale('dpLocale', locale.de);
      dateFormat = 'yyyy-MM-dd';
      break;
    }
    case 'sv-SE': {
      registerLocale('dpLocale', locale.sv);
      dateFormat = 'yyyy-MM-dd';
      break;
    }
    default:
      registerLocale('dpLocale', locale.enUS);
  }

  return (
    <div>
      <style>
        {`
            .react-datepicker-wrapper {
              width: 100%;
            }
          `}
      </style>
      <DatePicker
        id={id}
        selected={date ? new Date(date * 1000) : null}
        customInput={<BaseInput id={`${id}-custom-input`} className="w100" />}
        onChange={onChange}
        placeholderText={placeholderText}
        minDate={minDate}
        disabled={disabled}
        locale="dpLocale"
        dateFormat={dateFormat}
      />
    </div>
  );
};

export default DateDropdown;
